<div class="hmn-row__align">
  <app-shared-icon-button
    [icon]="'keyboard_arrow_left'"
    [button_class]="'hmn-icon__button-accent'">
  </app-shared-icon-button>

  <h4 class="hmn-margin__x2-left hmn-color__primary hmn-text__weight-700">Unit name 1</h4>
</div>
